import Eixos from '@/views/admin/eixos'
import EixoSave from '@/views/admin/eixos/Save'

export const eixos = [
  {
    path: 'eixos/list',
    component: Eixos,
    meta: {
      requiresAuth: true,
      adminAuth: true
    }
  },
  {
    name: 'admin_eixos_save',
    path: 'eixos/save/:id?/:name?',
    component: EixoSave,
    meta: {
      requiresAuth: true,
      adminAuth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/admin/eixos.js